export let pinMessageExtension = "ve0mpe";
export let unpinMessageExtension = "CeTzid";
export default {pinMessageExtension,unpinMessageExtension};